import { Route } from '@angular/router'
import { canActivateAuthRole } from '@mybitzer/core/auth/auth.guard'
import { canActivateBackoffice } from './backoffice.guard'
import {
  ACCOUNTING_ADMIN,
  AGENT_ADMIN,
  ASSET_ADMIN,
  CERTIFICATE_ADMIN,
  CHINA_ADMIN,
  CLAIM_ADMIN,
  CLAIM_SUBSIDIARY,
  CLAIM_REASON_ADMIN,
  CLAIM_WHITELIST_ADMIN,
  SPARE_PART_REQUEST_ADMIN,
  COMPANY_ADMIN,
  ORGANIZATION_ADMIN,
  ORGANIZATION_READ,
  ORGANIZATION_SUBSIDIARY,
  CONFIGURATION_ADMIN,
  CUSTOMER_ADMIN,
  DOCUMENT_ADMIN,
  ENVELOPE_ADMIN,
  EQUIPMENT_ADMIN,
  EXPORT_ADMIN,
  FACILITY_ADMIN,
  FEEDBACK_ADMIN,
  INGEST_ADMIN,
  INQUIRY_ADMIN,
  PID_ADMIN,
  PRODUCT_ADMIN,
  PRODUCTION_WEEK_import,
  SEARCH_ADMIN,
  SPARE_PART_ADMIN,
  STOCKLEVEL_import,
  THING_TEMPLATE_ADMIN,
  TRACE_ADMIN
} from '@mybitzer/core/auth/roles'
import { NotAuthorizedComponent } from '@mybitzer/shared/not-authorized/not-authorized.component'
import { PageNotFoundComponent } from '@mybitzer/ui/page-not-found/page-not-found.component'
import { ContentLayoutComponent } from '../home/content-layout/content-layout.component'

export const appRoutes: Route[] = [
  {
    path: '',
    title: 'MyBITZER Back Office',
    canActivate: [canActivateBackoffice],
    loadComponent: () => import('../home/home.component').then((m) => m.HomeComponent),
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
      },
      {
        path: '',
        component: ContentLayoutComponent,
        children: [
          {
            path: 'home',
            title: 'My BITZER Back Office - Landing Page',
            canActivate: [canActivateAuthRole],
            loadComponent: () => import('../core/landing-page/landing-page/landing-page.component').then((c) => c.LandingPageComponent)
          },
          {
            path: 'search',
            title: 'MyBITZER Back Office - Search',
            data: { roles: [SEARCH_ADMIN] },
            canActivate: [canActivateAuthRole],
            loadChildren: () => import('../core/search/search.routes').then((m) => m.routes)
          },
          {
            path: 'feedback',
            title: 'MyBITZER Back Office - Feedback',
            data: { roles: [FEEDBACK_ADMIN] },
            canActivate: [canActivateAuthRole],
            loadChildren: () => import('../core/feedback/feedback.routes').then((m) => m.routes)
          },
          {
            path: 'inquiry',
            title: 'MyBITZER Back Office - Inquiry',
            data: { roles: [INQUIRY_ADMIN] },
            canActivate: [canActivateAuthRole],
            loadChildren: () => import('../core/inquiry/inquiry.routes').then((m) => m.routes)
          },
          {
            path: 'accounting',
            title: 'MyBITZER Back Office - Accounting',
            data: { roles: [ACCOUNTING_ADMIN] },
            canActivate: [canActivateAuthRole],
            loadChildren: () => import('../core/accounting/accounting.routes').then((m) => m.routes)
          },
          {
            path: 'company',
            title: 'MyBITZER Back Office - Company',
            data: { roles: [COMPANY_ADMIN] },
            canActivate: [canActivateAuthRole],
            loadChildren: () => import('../core/company/company.routes').then((m) => m.routes)
          },
          {
            path: 'organization',
            title: 'MyBITZER Back Office - Organization',
            data: { roles: [ORGANIZATION_READ, ORGANIZATION_ADMIN, ORGANIZATION_SUBSIDIARY] },
            canActivate: [canActivateAuthRole],
            loadChildren: () => import('../core/organization/organization.routes').then((m) => m.routes)
          },
          {
            path: 'member',
            title: 'MyBITZER Back Office - Member',
            data: { roles: [ORGANIZATION_READ, ORGANIZATION_ADMIN, ORGANIZATION_SUBSIDIARY] },
            canActivate: [canActivateAuthRole],
            loadChildren: () => import('../core/member/member.routes').then((m) => m.routes)
          },
          {
            path: 'customer',
            title: 'MyBITZER Back Office - Customer',
            data: { roles: [CUSTOMER_ADMIN] },
            canActivate: [canActivateAuthRole],
            loadChildren: () => import('../core/customer/customer.routes').then((m) => m.routes)
          },
          {
            path: 'stock-level',
            title: 'MyBITZER Back Office - StockLevel',
            data: { roles: [STOCKLEVEL_import] },
            canActivate: [canActivateAuthRole],
            loadChildren: () => import('../core/stock-level/stock-level.routes').then((m) => m.routes)
          },
          {
            path: 'facility',
            title: 'MyBITZER Back Office - Facility',
            data: { roles: [FACILITY_ADMIN] },
            canActivate: [canActivateAuthRole],
            loadChildren: () => import('../core/facility/facility.routes').then((m) => m.routes)
          },
          {
            path: 'ingest',
            title: 'MyBITZER Back Office - Ingest',
            data: { roles: [INGEST_ADMIN] },
            canActivate: [canActivateAuthRole],
            loadChildren: () => import('../core/ingest/ingest.routes').then((m) => m.routes)
          },
          {
            path: 'thing-template',
            title: 'MyBITZER Back Office - Thing',
            data: { roles: [THING_TEMPLATE_ADMIN] },
            canActivate: [canActivateAuthRole],
            loadChildren: () => import('../core/thing-template/thing-template.routes').then((m) => m.routes)
          },
          {
            path: 'production-week',
            title: 'MyBITZER Back Office - Production Week',
            data: { roles: [PRODUCTION_WEEK_import] },
            canActivate: [canActivateAuthRole],
            loadChildren: () => import('../core/production-week/production-week.routes').then((m) => m.routes)
          },
          {
            path: 'product-config',
            title: 'MyBITZER Back Office - Product Config',
            data: { roles: [PID_ADMIN] },
            canActivate: [canActivateAuthRole],
            loadChildren: () => import('../core/product-config/product-config.routes').then((m) => m.routes)
          },
          {
            path: 'document',
            title: 'MyBITZER Back Office - Document',
            data: { roles: [DOCUMENT_ADMIN] },
            canActivate: [canActivateAuthRole],
            loadChildren: () => import('../core/document/document.routes').then((m) => m.routes)
          },
          {
            path: 'certificate',
            title: 'MyBITZER Back Office - Certificate',
            data: { roles: [CERTIFICATE_ADMIN] },
            canActivate: [canActivateAuthRole],
            loadChildren: () => import('../core/certificate/certificate.routes').then((m) => m.routes)
          },
          {
            path: 'agent-setting',
            title: 'MyBITZER Back Office - Agent Setting',
            data: { roles: [AGENT_ADMIN] },
            canActivate: [canActivateAuthRole],
            loadChildren: () => import('../core/agent-setting/agent-setting.routes').then((m) => m.routes)
          },
          {
            path: 'tool-definition',
            title: 'MyBITZER Back Office - MCP Tool Settings',
            data: { roles: [AGENT_ADMIN] },
            canActivate: [canActivateAuthRole],
            loadChildren: () => import('../core/tool-definition/tool-definition.routes').then((m) => m.routes)
          },
          {
            path: 'conversation',
            title: 'MyBITZER Back Office - Conversation',
            data: { roles: [AGENT_ADMIN] },
            canActivate: [canActivateAuthRole],
            loadChildren: () => import('../core/conversation/conversation.routes').then((m) => m.routes)
          },
          {
            path: 'product',
            title: 'MyBITZER Back Office - Product',
            data: { roles: [PRODUCT_ADMIN] },
            canActivate: [canActivateAuthRole],
            loadChildren: () => import('../core/product/product.routes').then((m) => m.routes)
          },
          {
            path: 'asset',
            title: 'MyBITZER Back Office - Asset',
            data: { roles: [ASSET_ADMIN] },
            canActivate: [canActivateAuthRole],
            loadChildren: () => import('../core/asset/asset.routes').then((m) => m.routes)
          },
          {
            path: 'claim',
            title: 'MyBITZER Back Office - Claims',
            data: { roles: [CLAIM_ADMIN, CLAIM_SUBSIDIARY] },
            canActivate: [canActivateAuthRole],
            loadChildren: () => import('../core/claim/claim.routes').then((m) => m.routes)
          },
          {
            path: 'sparepart-request',
            title: 'MyBITZER Back Office - Spare Part Requests',
            data: { roles: [SPARE_PART_REQUEST_ADMIN] },
            canActivate: [canActivateAuthRole],
            loadChildren: () => import('../core/sparepart-request/sparepart-request.routes').then((m) => m.routes)
          },
          {
            path: 'claim-reason',
            title: 'MyBITZER Back Office - Claim Reason',
            data: { roles: [CLAIM_REASON_ADMIN] },
            canActivate: [canActivateAuthRole],
            loadChildren: () => import('../core/claim-reason/claim-reason.routes').then((m) => m.routes)
          },
          {
            path: 'claim-whitelist',
            title: 'MyBITZER Back Office - Claim Whitelist',
            data: { roles: [CLAIM_WHITELIST_ADMIN] },
            canActivate: [canActivateAuthRole],
            loadChildren: () => import('../core/claim-whitelist/claim-whitelist.routes').then((m) => m.routes)
          },
          {
            path: 'config',
            title: 'MyBITZER Back Office - Configuration',
            data: { roles: [CONFIGURATION_ADMIN] },
            canActivate: [canActivateAuthRole],
            loadChildren: () => import('../core/configuration/configuration.routes').then((m) => m.routes)
          },
          {
            path: 'equipment',
            title: 'MyBITZER Back Office - Equipment',
            data: { roles: [EQUIPMENT_ADMIN] },
            canActivate: [canActivateAuthRole],
            loadChildren: () => import('../core/equipment/equipment.routes').then((m) => m.routes)
          },
          {
            path: 'envelope',
            title: 'MyBITZER Back Office - Envelope',
            data: { roles: [ENVELOPE_ADMIN] },
            canActivate: [canActivateAuthRole],
            loadChildren: () => import('../core/envelope/envelope.routes').then((m) => m.routes)
          },
          {
            path: 'profile',
            title: 'Profile',
            canActivate: [canActivateAuthRole],
            loadChildren: () => import('../home/home.routes').then((c) => c.HOME_ROUTES)
          },
          {
            path: 'china',
            title: 'MyBITZER Back Office - China',
            data: { roles: [CHINA_ADMIN] },
            canActivate: [canActivateAuthRole],
            loadChildren: () => import('../core/china/china.routes').then((m) => m.routes)
          },
          {
            path: 'export',
            title: 'MyBITZER Back Office - Export',
            data: { roles: [EXPORT_ADMIN] },
            canActivate: [canActivateAuthRole],
            loadChildren: () => import('../core/export/export.routes').then((m) => m.routes)
          },
          {
            path: 'sparepart',
            title: 'MyBITZER Back Office - Spare Part',
            data: { roles: [SPARE_PART_ADMIN] },
            canActivate: [canActivateAuthRole],
            loadChildren: () => import('../core/sparepart/sparepart.routes').then((m) => m.routes)
          },
          {
            path: 'trace',
            title: 'MyBITZER Back Office - Trace',
            data: { roles: [TRACE_ADMIN] },
            canActivate: [canActivateAuthRole],
            loadChildren: () => import('../core/trace/trace.routes').then((m) => m.routes)
          }
        ]
      }
    ]
  },
  {
    path: 'not-authorized',
    component: NotAuthorizedComponent
  },
  {
    path: '**',
    component: PageNotFoundComponent
  }
]
